import { render } from "./DownloadableAssets.vue?vue&type=template&id=1495e279"
import script from "./DownloadableAssets.vue?vue&type=script&lang=js"
export * from "./DownloadableAssets.vue?vue&type=script&lang=js"

import "./DownloadableAssets.vue?vue&type=style&index=0&id=1495e279&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__